module.exports = __webpack_public_path__ + "r-v3/img/menu_meeting_note.fcf59476.png";